__turbopack_context__.v({
  "content": "style-module-scss-module__fzTDDW__content",
  "cta": "style-module-scss-module__fzTDDW__cta",
  "ctaLabel": "style-module-scss-module__fzTDDW__ctaLabel",
  "ctaWrapper": "style-module-scss-module__fzTDDW__ctaWrapper",
  "description": "style-module-scss-module__fzTDDW__description",
  "eyebrow": "style-module-scss-module__fzTDDW__eyebrow",
  "intro": "style-module-scss-module__fzTDDW__intro",
  "pills": "style-module-scss-module__fzTDDW__pills",
  "title": "style-module-scss-module__fzTDDW__title",
  "visual": "style-module-scss-module__fzTDDW__visual",
  "visualImage": "style-module-scss-module__fzTDDW__visualImage",
});
